import { ThreeView } from "../View3dWebCad";
import * as THREE from 'three';
import * as marietta3d from '../../../../marietta3d';
import * as marietta from '../../../../marietta';
import { ModelInfo } from "../View3dWebCadModelInfo";
import { matUtils } from "../../base";
import { attribute } from "../UtilityInfo";
import { VectorUtility } from "../../../graphicLibs/utility/vectorUtility";
import { webcadDefines } from "..";
import { SceneExtras } from "../sceneExtras";
import { Loader } from "./Loader";
import { OBBManager } from "../OBBManager";
import { OctreeManager } from "../Octree/OctreeManager";

export class itemLoader {

    private plan: marietta3d.AutoGen.AutoBase;
    private alternative: any;
    private id: string = ''; // ex) fur50_01, fur50_01_01
    private _partType: webcadDefines.partTypes;

    // マウスに追従させるかどうか
    public isMouseTracking = false;

    // itemId is white model
    constructor(public itemId: string, public index: string) {
        this.plan = ThreeView.get().planmgr.autoData;
        // alternative取得
        this.alternative = this.plan.alternative(this.itemId);
        this._partType = this.partType();

        // アイテムのurlを取得
        const url = this.getURL();

        // アイテムの読み込み
        if (this.isMouseTracking) {
            this.load(url);
        } else {
            this.load_(url);
        }

        // 表示中の左メニューを閉じる
        marietta.webcad.WebCADGlobal.itemChangeMenuCategories3d.reset();
    }

    protected partType(): string {
        const plan = ThreeView.get().planmgr.autoData;

        for (let i = 0; i < plan.sysAutoParts.length; i += 1) {
            if (plan.sysAutoParts[i].IsHit(this.itemId) === true) {
            return plan.sysAutoParts[i].type;
            }
        }
        console.warn('itemIdに一致するデーターがありません。');
        return 'lig';
    }

    protected extrasType(): webcadDefines.extraTypes {
        let extraType = new Map<webcadDefines.partTypes, webcadDefines.extraTypes>([
            [webcadDefines.PartType.furniture, webcadDefines.ExtrasType.FUR],
            [webcadDefines.PartType.equipment, webcadDefines.ExtrasType.EQU],
            [webcadDefines.PartType.light, webcadDefines.ExtrasType.LIGHT],
            [webcadDefines.PartType.exterior, webcadDefines.ExtrasType.EXT],
        ]);
        const result = extraType.get(this._partType);
        if (result == null) {
            console.error('error', this._partType);
        }
        return result;
    }

    protected extrasSubType(): webcadDefines.ExtrasSubType {
        let extraType = new Map<webcadDefines.partTypes, webcadDefines.ExtrasSubType>([
            [webcadDefines.PartType.furniture, webcadDefines.ExtrasSubType.FUR],
            [webcadDefines.PartType.equipment, webcadDefines.ExtrasSubType.EQU],
            [webcadDefines.PartType.light, webcadDefines.ExtrasSubType.LIGHT],
            [webcadDefines.PartType.exterior, webcadDefines.ExtrasSubType.EXT],
        ]);
        const result = extraType.get(this._partType);
        if (result == null) {
            console.error('error', this._partType);
        }
        return result;
    }
    protected createController(object: THREE.Object3D) {

    }

    protected removeController() {

    }

    //メジャーの作成
    protected createMeasure(object: THREE.Object3D) {

    }
    //メジャーの削除
    protected removeMeasure() {

    }

    protected location(e): boolean {
        return false;
    }

    private whiteModel(): boolean {
        return Number(this.index) == 0
    }

    // アイテムのurlを取得
    protected getURL() {
        const root = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_3d_url}item/`;

        if (this.whiteModel()) {
            // ホワイトモデル
            this.id = this.itemId;
            return `${root}${this.itemId}.glb`;
        } else {
            // ホワイトモデル以外
            this.id = `${this.itemId}_${this.index}`;
            const filename = this.alternative[Number(this.index)-1].fileName;
            return `${root}${filename}`;
        }
    }

    // アイテムの読み込み
    public load_(url: string) {
        const loader = new Loader(url).getLoader();

        marietta.WebCADGlobal.showBusy(marietta.webcad.collection.WebCADMessages.getText('BUSY_LOADING_3D_OBJECT'));
        
        return loader.loadAsync(url).then((glb) => {
            console.log(`Item${url}`);
            
            // データをセット
            const object = glb.scene;
            this.setData(object);
            
            object.userData.obb = new OBBManager(object);

            // マテリアル適用
            ThreeView.get().matmgr.adjustMaterials([object]);

            // シーンに追加
            ThreeView.get().wcItemmgr.addItemShapes(object);

            // 壁の場合は向きを設定
            const selectManager = ThreeView.get().ObjectSelectManager;
            if (selectManager.type == webcadDefines.ExtrasSubType.INNERWALL) {
                this.setQuaterninon(object, selectManager.normal);
            }

            // 位置
            object.position.set(selectManager.intersectPoint.x, selectManager.intersectPoint.y, selectManager.intersectPoint.z);

            ThreeView.get().wcItemmgr.addHouseData(object);
            ThreeView.get().OctreeManager = new OctreeManager(ThreeView.get().wcItemmgr.houseData);
            // 画角内判定
            ThreeView.get().CameraTarget.getTargets(ThreeView.get().wcCameras.camera.me, ThreeView.get().OctreeManager.nodeStatus);

            // アイテム登録
            this.regist(object);

            // 2D連携
            const guid = this.addObject(object);

            // modelInfo にスケールを入れる前に、置いた UB の高さを合わせる
            this.fitUnitBathToCeiling(object, guid);

            // 配置後にmodelInfoに値をセットする
            this.setModelInfo(object, guid);

            // extras更新
            new SceneExtras(ThreeView.get().wcItemmgr.GltfExtras, object).create();

            marietta.WebCADGlobal.hideBusyStrict();
        });

    }

    // 壁アイテムの向きを調節
    public setQuaterninon(object: THREE.Object3D, normal: THREE.Vector3) {
        // 形状の正のz軸ベクトル
        const ObjZAxis = object.getWorldDirection(new THREE.Vector3()).normalize();

        // 回転角rad取得
        const rad = ObjZAxis.angleTo(normal);

        // 回転軸を取得
        const axisRotation = ObjZAxis.cross(normal).normalize(); 
        if (axisRotation.length() < 0.01) {
            axisRotation.copy(new THREE.Vector3(0, 1, 0));
        }

        // 配置オブジェクトのQuaternionを取得
        const quaternion = object.quaternion;

        // 回転させるためのQuaternionを作成
        const target = new THREE.Quaternion();
        target.setFromAxisAngle(axisRotation, rad);

        // 配置オブジェクトの回転
        quaternion.multiply(target);
    }

    // アイテムの読み込み
    public load(url: string) {
        const loader = new Loader(url).getLoader();

        return loader.loadAsync(url).then((glb) => {
            console.log(`Item${url}`);

            ThreeView.get().isOperation = true;

            // データをセット
            const object = glb.scene;
            this.setData(object);

            // マテリアル適用
            ThreeView.get().matmgr.adjustMaterials([object]);

            // シーンに追加
            ThreeView.get().wcItemmgr.addItemShapes(object);

            // 設置するための移動コントローラー作成
            this.createController(object);

            object.userData.obb = new OBBManager(object);

            ThreeView.get().ItemDragManager.dispatchEvent( { type: webcadDefines.WebCadEventNames.unSelectedObject } );

            //メジャーの作成
            this.createMeasure(object);

            const element = this.getElement();

            const event = (e) => {
                marietta.webcad.WebCADGlobal.itemChangeMenuCategories3d.reset();

                ThreeView.get().isOperation = false;

                //メジャーの削除
                this.removeMeasure();

                // 設置するためのコントローラーを破棄
                this.removeController();

                // 壁でなかったら
                if (this.location(e) == false) {
                    ThreeView.get().wcItemmgr.removeAddItemShapes(object);
                    element.removeEventListener('click', event);
                    return;
                }

                ThreeView.get().wcItemmgr.addHouseData(object);
                ThreeView.get().OctreeManager = new OctreeManager(ThreeView.get().wcItemmgr.houseData);
                // 画角内判定
                ThreeView.get().CameraTarget.getTargets(ThreeView.get().wcCameras.camera.me, ThreeView.get().OctreeManager.nodeStatus);

                // アイテム登録
                this.regist(object);

                // 2D連携
                const guid = this.addObject(object);

                // modelInfo にスケールを入れる前に、置いた UB の高さを合わせる
                this.fitUnitBathToCeiling(object, guid);

                // 配置後にmodelInfoに値をセットする
                this.setModelInfo(object, guid);

                // extras更新
                new SceneExtras(ThreeView.get().wcItemmgr.GltfExtras, object).create();

                element.removeEventListener('click', event);
            }
            // 設置時のイベント処理
            element.addEventListener('click', event);
        }).catch((message) => {
            console.log(`not found data`);
        });
    }

    // 置いた UB は、置いた部屋の天井高さにする（2D の住設メニューから置いたときと同じ。UB 以外は何もしない）
    protected fitUnitBathToCeiling(object: THREE.Object3D, guid: string): void {
        const item: marietta.webcad.item.MonicaObject = marietta.webcad.WebCADGlobal.layerGroup.getItemWithGuid(guid);
        if (!item) {
            return;
        }
        const beforeDepth: number = item.itemInfo.depth;
        marietta.webcad.util.UnitBathUtil.fitToCeiling(item);
        if (item.itemInfo.depth !== beforeDepth) {
            ThreeView.get().fitHeightTo2D(object, item);
        }
    }

    // 配置後にmodelInfoに値をセットする
    protected setModelInfo(object: THREE.Object3D, guid): void {
        object.userData.modelInfo.setTranslate(object.position.x, object.position.y, object.position.z);
        object.userData.modelInfo.setRotation(object.rotation.x, object.rotation.y, object.rotation.z);
        object.userData.modelInfo.setScale(object.scale.x, object.scale.y, object.scale.z);

        object.userData.modelInfo.reverse = false;
        object.userData.modelInfo.layer = `L${marietta.view3d.webcad.WebCadItemManager.getFloorFromPoint(ThreeView.get().wcCameras.camera.me.getWorldPosition(new THREE.Vector3()))}`;
        object.userData.modelInfo.idthreed = this.whiteModel() ?  '' : this.id;
        object.userData.modelInfo.uuid = guid;

        object.userData.modelInfo._typeExtras = this.extrasSubType();
        object.userData.modelInfo._subType = this.extrasSubType();

        let info: any;
        if (this.whiteModel()) {
            info = this.plan.autoPartsInfo(this.itemId);     //ホワイトアイテムのデータ取得
        } else {
            info = this.alternative[Number(this.index)-1];
        }

        const variation = {
            width: info.width,
            height: info.depth,
            idthreed: object.userData.modelInfo.idthreed,
            // reverse: object.userData.modelInfo.reverse,
            reverse: (object.scale.x < 0)
        };

        marietta.webcad.WebCADGlobal.change2Dfrom3D(object.userData.modelInfo.uuid, object.userData.modelInfo.code, variation);
    }

    // 読み込んだオブジェクトにデータをセット
    protected setData(object: THREE.Object3D): void {
        // 階データをセット
        const floor = `L${marietta.view3d.webcad.WebCadItemManager.getFloorFromPoint(ThreeView.get().wcCameras.camera.me.getWorldPosition(new THREE.Vector3()))}`;
        object.userData.layer = floor;
        
        // modelInfoの構築 暫定
        object.userData.modelInfo = new ModelInfo(this._partType, {code: this.itemId});

        const info: any = this.plan.autoPartsInfo(this.itemId);
        const attribute_ = new attribute();
        attribute_.alternative = this.alternative;
        attribute_.thumbnail = info.thumbnail;
        attribute_.objectId = this.itemId;
        attribute_.alternative = this.alternative;
        attribute_.objectId = object.userData.modelInfo.code;
        attribute_.objectName = `${this.id}.glb`;

        object.userData.attribute = attribute_;
    }

    // 2D連携
    protected addObject(object: THREE.Object3D) {
        const extras = ThreeView.get().wcItemmgr.GltfExtras;
        const position = object.getWorldPosition(new THREE.Vector3);
        // 左下原点を左上原点に変換
        const center = marietta.webcad.WebCADGlobal.itemManager.changePoint(extras.model_center[0], extras.model_center[1]);
        const x = position.x * 1000 + center.x;
        const y = position.y * 1000;
        const z = position.z * 1000 + center.y;
        const rotation = THREE.MathUtils.radToDeg(VectorUtility.rotaion(object)) * -1;
        const floor = marietta.view3d.webcad.WebCadItemManager.getFloorFromPoint(ThreeView.get().wcCameras.camera.me.getWorldPosition(new THREE.Vector3()))
        return marietta.webcad.WebCADGlobal.itemManager.add2Ditem(this.itemId, x, z, y, rotation, floor); // 2D通知
    }

    // アイテム登録
    protected regist(object: THREE.Object3D): void {
        ThreeView.get().wcItemmgr.furnitureObjects.push(<THREE.Group>(object));
        ThreeView.get().wcItemmgr.registFloorObject(<THREE.Object3D>(object));
        matUtils.turnOffLights(<THREE.Group>object);
    }

    protected getElement(): HTMLElement {
        if (ThreeView.get().wcCameras. isOrbitCameraMode()) return ThreeView.get().container;
        else return ThreeView.get().wcRenderer.me.domElement;
    }
}
